import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { NgModule, provideZoneChangeDetection } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireAnalyticsModule, ScreenTrackingService, UserTrackingService } from '@angular/fire/compat/analytics';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { environment } from '../environments/environment';
import { HeaderComponent } from './views/shared/header/header.component';
import { NavigationBarComponent } from './views/shared/navigation-bar/navigation-bar.component';
import { FooterComponent } from './views/shared/footer/footer.component';
import { AuthenticationComponent } from './views/shared/authentication/authentication.component';
import { PasswordResetComponent } from './views/shared/authentication/components/password-reset/password-reset.component';
import { RegisterComponent } from './views/shared/authentication/components/register/register.component';
import { RacesComponent } from './views/races/races.component';
import { EntriesComponent } from './views/entries/entries.component';
import { EventsComponent } from './views/events/events.component';
import { RaceCreateComponent } from './views/races/race-create/race-create.component';
import { RaceComponent } from './views/races/race/race.component';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EventCreateComponent } from './views/events/event-create/event-create.component';
import { EventListComponent, NgbdSortableHeader } from './views/events/event-list/event-list.component';
import { EventComponent } from './views/events/event/event.component';
import { EntryComponent } from './views/entries/entry/entry.component';
import { EntryListComponent } from './views/entries/entry-list/entry-list.component';
import { EntryCreateComponent } from './views/entries/entry-create/entry-create.component';
import { DateTimePickerComponent } from './views/shared/components/date-time-picker/date-time-picker.component';
import { RouterModule } from '@angular/router';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { AsyncPipe } from '@angular/common';
// import { AngularFireAuthModule } from "@angular/fire/compat/auth";
// import { getAnalytics, provideAnalytics, ScreenTrackingService as ScreenTrackingService_alias, UserTrackingService as UserTrackingService_alias } from '@angular/fire/analytics';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    NavigationBarComponent,
    FooterComponent,
    AuthenticationComponent,
    PasswordResetComponent,
    RegisterComponent,
    RacesComponent,
    EntriesComponent,
    EventsComponent,
    RaceCreateComponent,
    RaceComponent,
    EventCreateComponent,
    EventListComponent,
    EventComponent,
    EntryComponent,
    EntryListComponent,
    EntryCreateComponent,
    DateTimePickerComponent,
    NgbdSortableHeader,
  ],
  imports: [
    BrowserModule,
    RouterModule,
    FormsModule,
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
    AngularFirestoreModule,
    // AngularFireAuthModule,
    NgbModule,
    AsyncPipe,
  ],
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    // provideClientHydration(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    // provideAnalytics(() => getAnalytics()),
    ScreenTrackingService,
    UserTrackingService,
    // ScreenTrackingService_alias,
    // UserTrackingService_alias,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
